
import React from "react";
import ReactDom from "react-dom";
import App from "../src/components/App"

ReactDom.render(
    <App></App>,document.getElementById("root"));